import { useEffect, useState } from "react";
import MatrixData from "./../Users/Components/MatrixData";
import Table from "./../Users/Components/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilters,
  usersByPerformance,
} from "../../../redux/actions/dashboard";
import Filters from "../Components/Filters";
import { USER_FILTER } from "../../../redux/actions/types";
import { userActiveFilter } from "../../../helper/general";

const Users = () => {
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.dashboard.userData);
  const userFilter = useSelector((state) => state.dashboard.userFilter);

  const [activePage, setActivePage] = useState(1);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    dispatch(usersByPerformance({ ...userFilter, pageNo: (activePage - 1), pageSize: 10 }));
  }, [reload]);

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setActivePage(pageNumber);
    dispatch(usersByPerformance({ ...userFilter, pageNo: page, pageSize: 10 }));
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const data = { ...userFilter };
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1);
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(USER_FILTER, data));
    setActivePage(1);
    setReload(Math.random());
  };

  return (
    <div className="container-fluid">
      <Filters handleFilterChange={handleFilterChange} filterData={userFilter} activeFilter={userActiveFilter} />
      <MatrixData stats={userData} />
      <Table data={userData?.paginatedResponse} activePage={activePage} handlePageChange={handlePageChange} />
    </div>
  );
};

export default Users;
